export default function NovoPage() {
  return (
    <div className="min-h-screen page-bg py-8">
      <div className="container mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-4">
            New Project
          </h1>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Create a new project with our powerful tools and integrations.
          </p>
        </div>
        
        <div className="max-w-2xl mx-auto">
          <div className="card">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-6">Project Settings</h2>
            
            <form className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Project Name
                </label>
                <input
                  type="text"
                  placeholder="Enter project name"
                  className="input block w-full"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Description
                </label>
                <textarea
                  rows={3}
                  placeholder="Project description (optional)"
                  className="input block w-full"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Project Type
                </label>
                <select className="input block w-full">
                  <option value="">Select project type</option>
                  <option value="web">Web Application</option>
                  <option value="mobile">Mobile App</option>
                  <option value="api">API Service</option>
                  <option value="other">Other</option>
                </select>
              </div>
              
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="enable-storage"
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 dark:focus:ring-blue-600 border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700"
                />
                <label htmlFor="enable-storage" className="ml-2 block text-sm text-gray-900 dark:text-gray-100">
                  Enable Supabase Storage
                </label>
              </div>
              
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="enable-auth"
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 dark:focus:ring-blue-600 border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700"
                />
                <label htmlFor="enable-auth" className="ml-2 block text-sm text-gray-900 dark:text-gray-100">
                  Enable Authentication
                </label>
              </div>
              
              <div className="pt-4">
                <button type="submit" className="btn-primary w-full">
                  Create Project
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
